<template>
    <span class="multi-user-icon" aria-hidden="true">
    <span class="dx-icon-user user-3"></span>
    <span class="dx-icon-user user-2"></span>
    <span class="dx-icon-user user-1"></span>
    </span>    
</template>

<style lang="scss" scoped>
.multi-user-icon {
  position: relative;
  display: inline-block;
  width: 26px;
  height: 20px;
  color: #f01;
}

.multi-user-icon:hover {
  cursor: pointer;
}

.multi-user-icon .dx-icon-user {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;  
}

.multi-user-icon .user-1 {
  transform: translate(10px, 2px) scale(0.82);
  z-index: 3;
}

.multi-user-icon .user-2 {
  transform: translate(4px, 4px) scale(1);
  z-index: 2;
}

.multi-user-icon .user-3 {
  transform: translate(-3px, 6px) scale(1.2);
  z-index: 1;
}
</style>